module.exports = __webpack_public_path__ + "static/media/YM80_6.6388e653.jpg";